import { render, staticRenderFns } from "./ReportListOverview.vue?vue&type=template&id=47d87b6a&scoped=true"
import script from "./ReportListOverview.vue?vue&type=script&lang=ts"
export * from "./ReportListOverview.vue?vue&type=script&lang=ts"
import style0 from "./ReportListOverview.vue?vue&type=style&index=0&id=47d87b6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d87b6a",
  null
  
)

export default component.exports